module.exports = __webpack_public_path__ + "img/da2b74cb9bfda82ba01f12eea53a68e.9fa7d966.png";